import { PortableText } from '@portabletext/react';
import imageUrlBuilder from '@sanity/image-url'
import { client } from '../../sanityClient'

const builder = imageUrlBuilder(client)
const urlFor = (source) => builder.image(source)

const portableTextComponents = {
  marks: {
    en: ({ children }) => <span className="font-outfit">{children}</span>,
    jp: ({ children }) => <span className="font-kleeone">{children}</span>,
    cta: ({ children }) => <span className="sub-bold">{children}</span>,
    link: ({ children, value }) => {
      const { href, openInNewTab } = value || {}
      return (
        <a
          href={href}
          target={openInNewTab ? "_blank" : "_self"}
          rel={openInNewTab ? "noopener noreferrer" : undefined}
          className="underline"
        >
          {children}
        </a>
      );
    },
  },
  block: {
    normal: ({ children }) => <p className="">{children}</p>,
  },
  list: {
    bullet: ({ children }) => <ul className="">{children}</ul>,
    number: ({ children }) => <ol className="">{children}</ol>,
  },
  listItem: {
    listItem: ({ children }) => <li className="">{children}</li>,
  },
  types: {
    image: ({ value }) => {
      if (!value?.asset?._ref) return null;
      return (
        <div className="flex justify-center my-6">
          <img
            style={{ maxWidth: "100%" }}
            src={urlFor(value).url()}
            alt={value.alt || ""}
            className=""
          />
        </div>
      );
    },
  },
};

const hasDescription = (description) =>
  Array.isArray(description) && description.length > 0;

const BookItem = ({ title, subTitle = "", image, bookTitle, price, link, linkText, description }) => {
  const showDescription = hasDescription(description);

  return (
    <div className={`book-item-section${showDescription ? " has-description" : ""}`}>
      <div className="book-title font-amaticsc-bold">
        <p className="book-sub-title">{title}</p>
        <p className="book-sub-title">{subTitle}</p>
      </div>
      <div className="book-item-view">
        <div className="book-img-view">
          <img src={urlFor(image).url()} className="book-image" alt="book-image" />
        </div>
        <h3 className="book-desc font-outfit">{bookTitle}</h3>
        <hr className="hr-line" />
        <div className="book-price font-outfit-bold">{price}</div>
      </div>
      <div className="book-action-view">
        <a
          href={link ?? "https://www.amazon.com/Segmental-Phonology-Optimality-Theory-Representations/dp/0521790573"}
          rel="noreferrer"
          target="_blank"
          className="book-buy-btn font-outfit-bold"
        >
          {linkText ?? "Buy Now"}
        </a>
      </div>
      {showDescription && (
        <div className="portable-text-container prose max-w-none w-full mx-0 prose-p:my-0 book-item-description font-outfit">
          <PortableText value={description} components={portableTextComponents} />
        </div>
      )}
    </div>
  );
};

export default BookItem;
